import { render } from "./Skeleton.vue?vue&type=template&id=e899f52e&ts=true"
import script from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/skeleton/Skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e899f52e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e899f52e', __exports__)) {
    api.reload('e899f52e', __exports__)
  }
  
  module.hot.accept("./Skeleton.vue?vue&type=template&id=e899f52e&ts=true", () => {
    api.rerender('e899f52e', render)
  })

}


export default __exports__